import strings from "../../../res/strings";

const required = (value) => {
  return value || typeof value === "number"
    ? undefined
    : strings.lib_common_validation_error_required;
};

export { required };
